import React from 'react';
import Icon from '../../../components/AppIcon';

import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  isMobileOpen, 
  onMobileClose 
}) => {
  const skillOptions = [
    { value: 'marketing', label: 'Marketing & Communications' },
    { value: 'technology', label: 'Technology & IT' },
    { value: 'design', label: 'Design & Creative' },
    { value: 'finance', label: 'Finance & Accounting' },
    { value: 'legal', label: 'Legal & Compliance' },
    { value: 'education', label: 'Education & Training' },
    { value: 'healthcare', label: 'Healthcare & Medical' },
    { value: 'construction', label: 'Construction & Trades' },
    { value: 'writing', label: 'Writing & Content' },
    { value: 'event', label: 'Event Planning' }
  ];

  const causeOptions = [
    { value: 'animals', label: 'Animal Welfare' },
    { value: 'children', label: 'Children & Youth' },
    { value: 'education', label: 'Education' },
    { value: 'environment', label: 'Environment' },
    { value: 'health', label: 'Health & Wellness' },
    { value: 'homeless', label: 'Homelessness' },
    { value: 'seniors', label: 'Senior Citizens' },
    { value: 'arts', label: 'Arts & Culture' },
    { value: 'community', label: 'Community Development' },
    { value: 'disaster', label: 'Disaster Relief' }
  ];

  const timeCommitmentOptions = [
    { value: 'one-time', label: 'One-time Event' },
    { value: 'weekly', label: 'Weekly Commitment' },
    { value: 'monthly', label: 'Monthly Commitment' },
    { value: 'flexible', label: 'Flexible Schedule' },
    { value: 'ongoing', label: 'Ongoing Project' }
  ];

  const locationOptions = [
    { value: 'remote', label: 'Remote/Virtual' },
    { value: 'local', label: 'Local (Within 10 miles)' },
    { value: 'regional', label: 'Regional (Within 50 miles)' },
    { value: 'anywhere', label: 'Anywhere' }
  ];

  const handleSkillChange = (value) => {
    onFilterChange('skills', value);
  };

  const handleCauseChange = (value) => {
    onFilterChange('causes', value);
  };

  const handleTimeCommitmentChange = (value) => {
    onFilterChange('timeCommitment', value);
  };

  const handleLocationChange = (value) => {
    onFilterChange('location', value);
  };

  const handleRemoteChange = (e) => {
    onFilterChange('remoteOnly', e?.target?.checked);
  };

  const handleWeekendChange = (e) => {
    onFilterChange('weekendOnly', e?.target?.checked);
  };

  const handleImpactChange = (e) => {
    onFilterChange('highImpact', e?.target?.checked);
  };

  return (
    <>
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onMobileClose}
          aria-hidden="true"
        />
      )}
      <div className={`
        fixed lg:sticky top-16 left-0 h-[calc(100vh-4rem)] w-80 bg-card border-r border-border
        overflow-y-auto custom-scrollbar z-50 lg:z-0
        transition-transform duration-300 lg:translate-x-0
        ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="p-6 space-y-6">
          <div className="flex items-center justify-between lg:justify-start">
            <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
              <Icon name="SlidersHorizontal" size={20} />
              Filters
            </h2>
            <button
              onClick={onMobileClose}
              className="lg:hidden p-2 hover:bg-muted rounded-md"
              aria-label="Close filters"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          <div className="space-y-4">
            <Select
              label="Skills"
              placeholder="Select skills"
              options={skillOptions}
              value={filters?.skills}
              onChange={handleSkillChange}
              multiple
              searchable
              clearable
            />

            <Select
              label="Causes"
              placeholder="Select causes"
              options={causeOptions}
              value={filters?.causes}
              onChange={handleCauseChange}
              multiple
              searchable
              clearable
            />

            <Select
              label="Time Commitment"
              placeholder="Select commitment"
              options={timeCommitmentOptions}
              value={filters?.timeCommitment}
              onChange={handleTimeCommitmentChange}
            />

            <Select
              label="Location"
              placeholder="Select location"
              options={locationOptions}
              value={filters?.location}
              onChange={handleLocationChange}
            />

            <div className="pt-4 border-t border-border">
              <CheckboxGroup label="Additional Filters">
                <Checkbox
                  label="Remote opportunities only"
                  checked={filters?.remoteOnly}
                  onChange={handleRemoteChange}
                />
                <Checkbox
                  label="Weekend availability"
                  checked={filters?.weekendOnly}
                  onChange={handleWeekendChange}
                />
                <Checkbox
                  label="High-impact projects"
                  checked={filters?.highImpact}
                  onChange={handleImpactChange}
                />
              </CheckboxGroup>
            </div>

            <Button
              variant="outline"
              fullWidth
              onClick={onClearFilters}
              iconName="RotateCcw"
              iconPosition="left"
            >
              Clear All Filters
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;